<template>
  <div class="grid">
    <div class="col-12 md:col-12">
      <Message
        @close="errorMsg = null"
        class="fadeinUp"
        v-if="errorMsg"
        severity="error"
        key="error"
        >{{ errorMsg }}</Message
      >
      <div class="">
        <div>
          <div class="text-xl font-bold mb-1">Change Password</div>
          <div class="mb-4">Easy! Provide your new password</div>
          <hr />
        </div>
        <form ref="observer" tag="form" @submit.prevent="submitForm()">
          <div class="grid mt-2">
            <div class="col-12 sm:col-12">
              <div class="mb-2 font-bold text-sm">Current Password *</div>
              <div id="ctrl-lastname-holder">
                <Password
                  class="w-full"
                  :class="getErrorClass('oldpassword')"
                  inputClass="w-full"
                  :feedback="false"
                  :toggleMask="true"
                  label="Current Password"
                  placeholder="Current Password"
                  v-model="formData.oldpassword"
                />
              </div>
            </div>
            <div class="col-12 sm:col-6">
              <div class="mb-2 font-bold text-sm">New Password *</div>
              <div id="ctrl-firstname-holder">
                <Password
                  class="w-full"
                  :class="getErrorClass('newpassword')"
                  inputClass="w-full"
                  :toggleMask="true"
                  label="New Password"
                  placeholder="New Password"
                  v-model="formData.newpassword"
                  ><template #header>
                    <h6>Create your new password</h6>
                  </template>
                  <template #content></template>
                  <template #footer>
                    <Divider />
                    <p class="mt-2">Suggestions</p>
                    <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                      <li>At least one lowercase</li>
                      <li>At least one uppercase</li>
                      <li>At least one numeric value</li>
                      <li>Minimum 6 characters</li>
                    </ul>
                  </template></Password
                >
              </div>
            </div>
            <div class="col-12 sm:col-6">
              <div class="mb-2 font-bold text-sm">Confirm Password *</div>
              <div id="ctrl-lastname-holder">
                <Password
                  class="w-full"
                  :class="getErrorClass('confirmpassword')"
                  inputClass="w-full"
                  :feedback="false"
                  :toggleMask="true"
                  label="Confirm new password"
                  placeholder="Confirm new password"
                  v-model="formData.confirmpassword"
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="my-3 text-center">
            <Button
              type="submit"
              icon="pi pi-send"
              label="Change Password"
              :loading="saving"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required, sameAs } from "@vuelidate/validators";
import { useApp } from "@/composables/app";
export default {
  setup() {
    const app = useApp();
    return { app, v$: useVuelidate() };
  },
  props: {
    apiUrl: {
      type: String,
      default: "account/changepassword",
    },
  },
  data() {
    return {
      errorMsg: null,
      saving: false,
      submitted: false,
      formData: {
        oldpassword: "",
        newpassword: "",
        confirmpassword: "",
      },
    };
  },
  validations() {
    let formData = {
      oldpassword: { required },
      newpassword: { required },
      confirmpassword: {
        required,
        sameAsPassword: sameAs(this.formData.newpassword),
      },
    };
    return { formData };
  },
  methods: {
    async submitForm() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.app.flashMsg(
          "Form is invalid",
          "Please complete the form",
          "error"
        );
        return;
      }
      this.saving = true;
      let payload = this.formData;
      let url = this.apiUrl;
      this.$api.post(url, payload).then(
        (response) => {
          this.saving = false;
          this.submitted = false;
          this.resetForm();
          this.app.flashMsg("Password change completed");
        },
        (request) => {
          this.saving = false;
          this.errorMsg =
            request?.response?.data || "Unable to complete request";
        }
      );
    },
    getErrorClass(field) {
      let isValid = this.v$.formData[field].$invalid && this.submitted;
      return { "p-invalid": isValid };
    },
    resetForm() {
      this.formData = { oldpassword: "", newpassword: "", confirmpassword: "" };
      this.$refs.observer.reset();
    },
  },
};
</script>
